import React from "react";

import Paginator from "../../Paginator/containers/PaginatorContainer";
import PublicidadTable from "./PublicidadTable";

function OperativoComponent
(props) {
  const { state } = props
  return (
    <div className="content-line">
      <div className="line line-100">
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px auto' }}>
          <div style={{ display: 'flex', height: '50px' }}>
            <div className={(state.searchError) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Busqueda'
                className="kml-input"
                value={state.search}
                onKeyUp={props.searchKeyUp}
                onChange={props.handlerSearch}
              />
            </div>
            <div onClick={props.onGetSearch} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
              <i className="fas fa-search"></i>
            </div>
            {
              state.loading &&
              <div className="flex-center">
                <i className="fas fa-spinner spin primary-color fa-2x"></i>
              </div>
            }
          </div>
        </div>
        <PublicidadTable list={state.operList} onOpen={props.onOpen} session={props.session} onGetPdf={props.onGetPdf} />
        <Paginator
          control={state.control}
          click={props.onChangePage}
          setKey="user-update-table-key-"
        />
      </div>
    </div>
  );
}

export default OperativoComponent
;
